import { PModal, PText, PGrid, PGridItem, PButtonPure, PSpinner } from '@porsche-design-system/components-react'
import React from 'react'
import { CSVLink } from 'react-csv'

import { getReporting } from '../../utils/api/Apps'

import { ReportingContext } from '../../utils/Context/ReportingContext'

import { PortalContext } from '../../utils/PortalContext'

import styles from './modal.module.css'

export default function ModalExport() {
  const { openModalExport, setOpenModalExport, loading, setLoading } = React.useContext(PortalContext)
  const { filter, startDate, endDate } = React.useContext(ReportingContext)
  const [exportData, setExportData] = React.useState([])
  const handleModalClose = () => {
    setOpenModalExport(false)
    setLoading(false)
  }

  React.useEffect(async () => {
    if (openModalExport) {
      setLoading(true)
      const data = await getReporting(filter, 'bydetailsexport')
        .then((res) => parseResponse(res))
        .then((val) => {
          return val === 'no Data selected' || val === undefined ? [] : val
        })
      setExportData(replaceNewLineForExport(data))
      setLoading(false)
    }
  }, [openModalExport])

  const replaceNewLineForExport = (data) => {
    return data.map((dat) => {
      return { ...dat, comment: dat.comment.replaceAll('\n', ' ') }
    })
  }

  const parseResponse = (res) => {
    return res
      .clone()
      .json()
      .catch(() => res.text())
  }

  const downloadFile = ({ data, fileName, fileType }) => {
    // Create a blob with the data we want to download as a file
    const blob = new Blob([data], { type: fileType })
    // Create an anchor element and dispatch a click event on it
    // to trigger a download
    const a = document.createElement('a')
    a.download = fileName
    a.href = window.URL.createObjectURL(blob)
    const clickEvt = new MouseEvent('click', {
      view: window,
      bubbles: true,
      cancelable: true
    })
    a.dispatchEvent(clickEvt)
    a.remove()
  }

  const exportToJson = async (e) => {
    e.preventDefault()
    downloadFile({
      data: JSON.stringify(exportData),
      fileName: 'Einzelbewertungen.json',
      fileType: 'text/json'
    })
  }

  return (
    <PModal open={openModalExport} heading='Datenexport' onClose={handleModalClose}>
      <PText>
        Ein kompletter Export der Einzelbewertungen für <br />
        Ihre App für den Zeitraum:{' '}
        <b>
          {startDate.toLocaleDateString('de-de', { year: 'numeric', month: '2-digit', day: '2-digit' })}
          {endDate !== null &&
            ' - ' + endDate.toLocaleDateString('de-de', { year: 'numeric', month: '2-digit', day: '2-digit' })}
        </b>
        <br />
        <br />
      </PText>
      <div className={styles.buttonWrapper}>
        {loading && <PSpinner className={styles.spinner} />}
        {!loading && (
          <PGrid>
            <PGridItem size={6}>
              <CSVLink data={exportData} filename='Einzelbewertungen.csv'>
                <PButtonPure icon='save'>
                  Download <b>CSV</b>
                </PButtonPure>
              </CSVLink>
            </PGridItem>
            <PGridItem size={6}>
              <PButtonPure onClick={exportToJson} icon='save'>
                Download <b>JSON</b>
              </PButtonPure>
            </PGridItem>
          </PGrid>
        )}
      </div>
    </PModal>
  )
}
